export default __webpack_public_path__ + "static/IN-8003_Quick_Installation_02-fca9ed44fbc6c965027d2acf157213d2.webp";